import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import AppShell from './shell/AppShell.vue';
import { router } from './shell/router';
import { auth0 } from './shell/auth/auth0';
import { appRootUrl } from './shell/auth/appRootUrl';
import { createSession, provideSession } from './shell/session/session';
import { TENANT_OPTIONS } from './shell/session/tenants';
import { performxTheme } from './shell/theme';

// Components and directives are auto-imported by vite-plugin-vuetify, so there is
// no `import * as components` here. Safe because nothing in this repo resolves a
// component dynamically through `:is`.
const vuetify = createVuetify({
    theme: { defaultTheme: 'performx', themes: { performx: performxTheme } },
});

const app = createApp(AppShell);

app.use(vuetify);

// ─────────────────────────────────────────────────────────────────────────────
// ORDER IS LOAD-BEARING: the router MUST be installed before Auth0.
//
// Auth0Plugin.install() reads the router off `app.config.globalProperties.$router`
// — there is no plugin option for it. Install Auth0 first and it receives
// `undefined`, so after a sign-in callback it still rewrites the URL to '/' but
// never calls router.push(appState.target). Every deep link then silently lands on
// the app index instead of the app the user asked for, with no error anywhere.
//
// Do not "tidy" these two lines by grouping them with the other .use() calls.
// ─────────────────────────────────────────────────────────────────────────────
app.use(router);
app.use(auth0);

provideSession(app, createSession(auth0, { tenants: TENANT_OPTIONS, returnTo: appRootUrl() }));

app.mount('#app');
